<template>
  <div id="app" v-touch:right="onSwipeLeft">
    <!-- 头部 -->
    <HeaderTop :show-download="showDownload" @handleClose="closeDowLoad" />

    <!-- 左侧导航 -->
    <leftNav v-show="show_left_nav" class="top-right-menu" @ListenChild="tabChange" />

    <!-- 视图窗口 -->
    <transition :name="transitionName" :mode="transitionMode" @before-enter="beforeEnter" @enter="enter"
      @after-enter="afterEnter">
      <router-view id="vier_port" :key="$route.fullPath" :show-download="showDownload" />
    </transition>

    <!-- 登录弹窗 -->
    <!-- <div
      v-show="is_show_wrap"f
      class="login-wrap"
      @click.stop="is_show_wrap = false"
    > -->
    <div v-if="is_show_wrap" class="login-wrap">
      <div class="login_regist_box">
        <img class="logo_icon" src="./assets/images/person/avt.png" alt="">
        <van-tabs v-model="active" class="tabs_box" :line-width="80" :line-height="1.5" animated @change="changeActive">
          <van-tab title="Registro">
            <template #title>
              <div class="myTitle">
                <span class="left_icon register" /> {{ $t("注册") }}
              </div>
            </template>
            <!-- 注册 -->
            <div v-if="active == 0" class="login-form" @click.stop="a = 1">
              <div class="tip colorf">
                {{ $t("仅支持账户注册") }}
              </div>
              <div class="item mt">
                <span class="icon">
                  <van-icon name="user" class="ricon" />
                </span>
                <span class="inputno">*</span>
                <input v-model.trim="register_data.username" type="text" class="inp" :placeholder="'Digite o Conta'">
              </div>
              <div v-if="
                register_data.username.length > 0 && register_data.username.length < 5 || register_data.username.length > 16
              " class="LRnotice">
                {{ $t("4-16位字符，支持英文/数字") }}
              </div>
              <div class="item">
                <span class="icon">
                  <van-icon name="lock" class="ricon" />
                </span>
                <span class="inputno">*</span>
                <input id="password1" v-model.trim="register_data.password" type="password" class="inp"
                  :placeholder="$t('输入密码')">
                <div v-show="!isShowPwd" style="margin-right: .15rem;" @click="ShowPwd(1)">
                  <svg class="showPwd" width="30" height="30" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/ç™»é™†æ³¨å†Œ/è¿”å›žæŒ‰é’®å¤‡ä»½ 2">
                      <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                      <path id="å½¢çŠ¶ç»“åˆ" fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.779 7.5446C14.6375 6.98232 13.3541 6.66708 12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C4.59664 13.7238 5.63335 15.0587 6.95504 16.0234L8.91771 14.1369C8.56561 13.5709 8.36343 12.8967 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C12.7879 8.50079 13.5105 8.74232 14.1003 9.15736L15.779 7.5446ZM20 12.1671C19.5466 10.9843 18.8392 9.92947 17.9458 9.06782L15.553 11.3677C15.6078 11.6244 15.6366 11.8918 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334C11.6653 15.8334 11.3424 15.7898 11.0364 15.7078L9.41274 17.2687C10.2299 17.5276 11.0993 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671ZM14.1073 12.7577C13.9015 13.5488 13.2865 14.1436 12.4858 14.316L14.1073 12.7577ZM13.011 10.2039C12.7114 10.0518 12.3687 9.96708 12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 12.4999 9.88568 12.8118 10.008 13.0903L13.011 10.2039Z"
                        fill="currentColor" />
                      <rect id="çŸ©å½¢_2" x="17.6742" y="6" width="1.5" height="16" rx="0.75"
                        transform="rotate(45 17.6742 6)" fill="" />
                    </g>
                  </svg>
                </div>
                <div v-show="isShowPwd" style="margin-right: .15rem;" @click="ShowPwd(1)">
                  <svg class="showText" width="30" height="30" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/ç™»é™†æ³¨å†Œ/æŸ¥çœ‹å¯†ç&nbsp;">
                      <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                      <path id="å½¢çŠ¶" fill-rule="evenodd" clip-rule="evenodd"
                        d="M12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C5.23657 15.3934 8.36343 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671C18.7634 8.94078 15.6366 6.66708 12 6.66708ZM12 15.8334C9.96342 15.8334 8.36343 14.2197 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C14.0366 8.50079 15.6366 10.1145 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334ZM12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 13.4134 10.7634 14.3671 12 14.3671C13.2366 14.3671 14.1817 13.4134 14.1817 12.1671C14.1817 10.9208 13.2366 9.96708 12 9.96708Z"
                        fill="" />
                    </g>
                  </svg>
                </div>
                <!-- <van-icon v-show="showPwd[1]" name="eye-o" class="pwdeye" />
            <van-icon v-show="!showPwd[1]" name="closed-eye" class="pwdeye"  /> -->
              </div>
              <div v-if="
                register_data.password.length > 0 &&
                register_data.password.length < 6 ||
                register_data.password.length > 18
              " class="LRnotice">
                {{ $t('4-16位字符，支持英文/数字') }}
              </div>
              <div class="streng-box">
                <span class="forSpan">{{ $t('力量') }}</span>
                <div class="schedule">
                  <span class="bg-span p-a" />
                  <span class="bg-span p-b" />
                  <span class="bg-span p-c" />
                  <span class="bg-span p-d" />
                  <span v-if="strength >= 1" class="add_span low p-a" />
                  <span v-if="strength >= 2" class="add_span centre p-b" />
                  <span v-if="strength >= 3" class="add_span tall p-c" />
                  <span v-if="strength >= 3" class="add_span tall p-d" />
                </div>
              </div>

              <div class="item">
                <span class="icon">
                  <van-icon name="lock" class="ricon" />
                </span>
                <span class="inputno">*</span>
                <input id="password2" v-model.trim="register_data.repassword" type="password" class="inp"
                  :placeholder="$t('请再次确认您的密码。')">
                <div v-show="!isShowPwd2" style="margin-right: .15rem;" @click="ShowPwd2(2)">
                  <svg class="showPwd" width="30" height="30" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/ç™»é™†æ³¨å†Œ/è¿”å›žæŒ‰é’®å¤‡ä»½ 2">
                      <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                      <path id="å½¢çŠ¶ç»“åˆ" fill-rule="evenodd" clip-rule="evenodd"
                        d="M15.779 7.5446C14.6375 6.98232 13.3541 6.66708 12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C4.59664 13.7238 5.63335 15.0587 6.95504 16.0234L8.91771 14.1369C8.56561 13.5709 8.36343 12.8967 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C12.7879 8.50079 13.5105 8.74232 14.1003 9.15736L15.779 7.5446ZM20 12.1671C19.5466 10.9843 18.8392 9.92947 17.9458 9.06782L15.553 11.3677C15.6078 11.6244 15.6366 11.8918 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334C11.6653 15.8334 11.3424 15.7898 11.0364 15.7078L9.41274 17.2687C10.2299 17.5276 11.0993 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671ZM14.1073 12.7577C13.9015 13.5488 13.2865 14.1436 12.4858 14.316L14.1073 12.7577ZM13.011 10.2039C12.7114 10.0518 12.3687 9.96708 12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 12.4999 9.88568 12.8118 10.008 13.0903L13.011 10.2039Z"
                        fill="currentColor" />
                      <rect id="çŸ©å½¢_2" x="17.6742" y="6" width="1.5" height="16" rx="0.75"
                        transform="rotate(45 17.6742 6)" fill="" />
                    </g>
                  </svg>
                </div>
                <div v-show="isShowPwd2" style="margin-right: .15rem;" @click="ShowPwd2(2)">
                  <svg class="showText" width="30" height="30" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/ç™»é™†æ³¨å†Œ/æŸ¥çœ‹å¯†ç&nbsp;">
                      <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                      <path id="å½¢çŠ¶" fill-rule="evenodd" clip-rule="evenodd"
                        d="M12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C5.23657 15.3934 8.36343 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671C18.7634 8.94078 15.6366 6.66708 12 6.66708ZM12 15.8334C9.96342 15.8334 8.36343 14.2197 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C14.0366 8.50079 15.6366 10.1145 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334ZM12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 13.4134 10.7634 14.3671 12 14.3671C13.2366 14.3671 14.1817 13.4134 14.1817 12.1671C14.1817 10.9208 13.2366 9.96708 12 9.96708Z"
                        fill="" />
                    </g>
                  </svg>
                </div>
                <!-- <van-icon v-show="showPwd[2]" name="eye-o" class="pwdeye" @click="ShowPwd(2)" />
            <van-icon v-show="!showPwd[2]" name="closed-eye" class="pwdeye" @click="ShowPwd(2)" /> -->
              </div>

              <div class="item mt" @click="showOption = !showOption">
                <img src="./assets/images/login/gqq.png" class="ricon_img" alt="">
                <div class="select">
                  <span> {{ $t('巴西雷亚尔 (BRL)') }}</span>
                </div>
                <van-icon name="arrow-down" class="arrow" />
                <div v-if="showOption" class="option_box">
                  <div class="mask" />
                  <div class="option_item">
                    <img src="./assets/images/login/gqq.png" class="ricon_img" alt="">
                    <div class="option">
                      <span>{{ $t('巴西雷亚尔 (BRL)') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="region_tips tip">
                {{ $t('货币决定第三方游戏和支付方式，并且无法修改。') }}
              </div>
              <!-- <div class="item mt">
                <span class="icon">
                  <i class="ricon el-icon-connection" />
                </span>
                <input v-model.trim="register_data.invite_code" :disabled="codeDisable" type="text" class="inp"
                  :placeholder="$t('邀请码')" @change="invitation_code_change">
              </div>
              <div v-if="!isTrueInvitation_code" class="LRnotice">
                {{ $t('请输入正确的邀请码。') }}
              </div> -->

              <div class="remeber2">
                <van-checkbox v-model="checked[1]" shape="square" icon-size="16px" checked-color="#04be02">
                  <span class="check_text">{{ $t('我已年满 18 岁，已阅读并同意使用条款') }}
                    <span> 《{{ $t('用户协议') }}》</span>
                  </span>
                </van-checkbox>
              </div>

              <div class="now-btn" :disabled="isSubmitting" :class="{ 'disabled-style': isSubmitting }"
                @click="submit_reigster">
                {{ isSubmitting ? 'Enviando...' : 'Registro' }}
              </div>
              <div class="loginrow">
                <span class="signup" @click="toSupport">{{ $t('客户支持') }}</span>
                <!-- <span class="signup">Jogar Grátis</span> -->
                <span class="signup" @click="login()">{{ $t('立即登录') }}</span>
              </div>
              <!-- <div
                class="loginrow"
                style="font-weight: 100"
              >
                ——
                <span>Outros métodos de início de sessãos</span>
                ——
              </div>
              <div class="lrgg">
                <img src="./assets/images/common/google.png">
              </div> -->
              <van-icon name="close" class="close_btn1" @click="closeWindow()" />
            </div>
          </van-tab>
          <van-tab title="Login">
            <template #title>
              <div class="myTitle">
                <span class="left_icon login" /> {{ $t('登录') }}
              </div>
            </template>
            <div v-if="active == 1" class="login-form" @click.stop="a = 1">
              <!-- <img src="./assets/images/logo/logo.png" class="lr_logo" alt="" /> -->
              <div class="tip colorf">
                {{ $t('仅支持账户登录') }}
              </div>
              <div class="item mt">
                <span class="icon">
                  <van-icon name="user" class="ricon" />
                </span>
                <span class="inputno">*</span>
                <input v-model.trim="data.username" type="text" class="inp" :placeholder="$t('输入账户')">
                <van-icon v-if="data.username.length > 0" name="close" class="pwdeye" @click="data.username = ''" />
              </div>
              <div v-if="data.username.length > 0 && data.username.length < 4 || data.username.length > 16"
                class="LRnotice">
                {{ $t('4-16位字符，支持英文/数字') }}
              </div>
              <div class="item">
                <span class="icon">
                  <van-icon name="lock" class="ricon" />
                </span>
                <span class="inputno">*</span>
                <input id="password0" v-model.trim="data.password" type="password" class="inp"
                  :placeholder="$t('输入密码')">
                <van-icon v-if="data.password.length > 0" name="close" class="pwdeye" @click="data.password = ''" />
                <van-icon v-if="showPwd[0]" name="eye-o" class="pwdeye colorc" @click="ShowPwd(0)" />
                <van-icon v-else name="closed-eye" class="pwdeye" @click="ShowPwd(0)" />
              </div>
              <div v-if="data.password.length > 0 && data.password.length < 6 || data.password.length > 18"
                class="LRnotice">
                {{ $t('密码长度为6至18个字符') }}
              </div>
              <div class="remeber">
                <div class="rem-left">
                  <van-checkbox v-model="checked[0]" shape="square" icon-size="16px" checked-color="#04be02" />
                  <span class="colorf ml-5">{{ $t('记住您的账户密码') }}</span>
                </div>
              </div>

              <div class="lg-btn" @click="submit_login()">
                {{ $t('登录') }}
              </div>

              <div class="loginrow">
                <!-- {{ $t("还没账号?") }} -->
                <span class="signup" @click="toSupport"> {{ $t('客户支持') }}</span>
                <!-- <span class="signup">Jogar Grátis</span> -->
                <span class="signup" @click.stop="register()"> {{ $t('注册账户') }}</span>

                <div class="rem-right">
                  {{ $t('忘记密码') }}
                </div>
              </div>
              <!-- <div
                class="loginrow"
                style="font-weight: 100"
              >
                ——
                <span>Outros métodos de início de sessãos</span>
                ——
              </div> -->
              <!-- <div class="lrgg">
                <img src="./assets/images/common/google.png">
              </div> -->

              <!-- <img
                src="./assets/images/common/close.png"
                class="close_btn1"
                alt=""
                @click="closeWindow()"
              > -->
              <van-icon name="close" class="close_btn1" @click="closeWindow()" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!-- 充值页面 -->
    <van-popup v-model="isShowRecharge" position="bottom" style="height: 100%;max-width:456px;left: auto;"
      class="recharge_box">
      <recharge />
    </van-popup>
    <van-popup v-model="isShowSupport" position="right" style="height: 100%;max-width:456px;right: auto;"
      class="recharge_box">
      <support :tab="supTab" />
    </van-popup>
    <!-- 注册后提醒页面 -->
    <van-popup v-model="register_end_modal" class="register_end_box">
      <div class="register_end">
        <div class="register_title">
          {{ $t('注册成功') }}
        </div>
        <div class="register_content">
          {{ $t('注册成功！立即游戏吧~') }}
        </div>
        <div class="register_btn" @click="openRecharge">
          {{ $t('立即充值') }}
        </div>
      </div>
    </van-popup>
    <div v-show="isShowBottom" :class="isShowRed ? 'bottom_dom red' : 'bottom_dom'" style="padding-bottom: 2rem;">
      <div class="actList">
        <div v-for="(item, index) in activ_list" :ref="`item-${index}`" class="act_item" @click="changeAct(index)">
          <div class="item-img">
            <img :class="act_active == index ? 'active' : ''" :src="getImagePath(index)" alt="">
          </div>
          <p class="act_name">
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <div v-show="isShowFt">
      <FtNav />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify, showNotify, Popup } from "vant";
import { Icon, Popover, Checkbox, CheckboxGroup } from "vant";
import router from "./router";
import Fetch from "./utils/fetch.js";
import FtNav from "./components/footer_nav/footer_nav.vue";
import leftNav from "./components/leftNav.vue";
import HeaderTop from "./components/header.vue";
import recharge from "./views/recharge/recharge.vue";
import { EventBus } from './utils/utils.js'
import support from "./views/support/support.vue"

Vue.use(Notify).use(Icon).use(Popover).use(Checkbox).use(CheckboxGroup).use(Popup);
export default {
  name: "App",
  components: {
    FtNav,
    leftNav,
    HeaderTop,
    recharge,
    support
  },
  data() {
    return {
      // 页面过渡动画相关
      transitionName: 'slide-left',
      transitionMode: 'out-in',
      isShowSupport: false,
      isBackNavigation: false,
      supTab: "",
      // 音效控制相关
      clickSoundEnabled: true, // 音效开关控制
      clickSoundPlaying: false, // 音效播放状态
      isSubmitting: false,
      isShowBottom: false,
      act_active: 0,
      isShowRed: false,
      isShowFt: true,
      isShowRecharge: false,
      showDownload: (() => {
        let u = navigator.userAgent;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
        let token = localStorage.getItem('token');
        let data = localStorage.getItem("dowLoad")
        if (token && !isIOS) {
          if ((!data || data && !JSON.parse(data).value || new Date(JSON.parse(data).date).getDate() !== new Date().getDate())) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      })(),
      checked: [true, true],
      showPwd: [false, false, false],
      user_balance: localStorage.getItem("user_balance") || 0,
      is_show_wrap: false,
      is_show_login: false,
      is_show_register: false,
      sync_timer: null,
      showUserinfo: false,
      showUser: false,
      show_left_nav: false,
      isTrueInvitation_code: true,
      activ_list: [
        {
          name: this.$t('邀请宝箱活动')
        },
        {
          name: ''
        },
        {
          name: ''
        },
        {
          name: this.$t('PG投注奖金')
        },
        {

          name: ''
        },
        {
          name: ''

        },
        { name: 'Recompensa de login de recarga contínua' },
      ],
      app: {},
      isShowPwd: false,
      isShowPwd2: false,
      data: {
        username: "",
        password: "",
      },
      codeDisable: false,
      register_data: {
        password: "",
        repassword: "",
        username: "",
        // invite_code: "",
      },
      active: 0,
      showOption: false,
      nowScrollTop: 0,
      token: localStorage.getItem("token") || '',
      register_end_modal: false
    };
  },
  computed: {
    strength() {
      //验证密码强度的函数
      var val = this.register_data.password || "";
      var lv = 0;
      if (val.match(/[a-z]/g)) {
        lv++;
      } //验证是否包含字母
      if (val.match(/[0-9]/g)) {
        lv++;
      } // 验证是否包含数字
      if (val.match(/(.[^a-z0-9])/g)) {
        lv++;
      } //验证是否包含字母，数字，字符
      if (val.length > 12) {
        lv++;
      }
      if (lv > 3) {
        lv = 4;
      }
      return lv;
    },
    // 音效状态显示
    clickSoundStatus() {
      return this.clickSoundEnabled ? '音效已开启' : '音效已关闭';
    }
  },
  watch: {
    show_left_nav: function () {
      setTimeout(() => {
        window.scrollTo(0, this.nowScrollTop)
        document.body.scrollTo(0, this.nowScrollTop)
      }, 50);
    },
    is_show_login(newval) {
      if (newval) {
        this.active = 1
      }
    },
    is_show_register(newval) {
      if (newval) {
        this.active = 0
      }
    },
    user_balance: function (newv) {
      localStorage.setItem("user_balance", newv);
    },
    $route: function (to, from) {
      console.log(to.path)

      // 控制过渡动画方向 - 统一使用左右滑动效果
      if (from) {
        // 检查是否是返回操作
        if (this.isBackNavigation) {
          this.transitionName = 'slide-right'
          this.isBackNavigation = false
        } else {
          this.transitionName = 'slide-left'
        }
      }
      if (
        to.path == "/subgame" ||
        to.path == "/vip" ||
        to.path == "/share" ||
        to.path == "/gameRecord" ||
        to.path == "/betReward" ||
        to.path == "/rechargeRecord" ||
        to.path == "/withdrawRecord" ||
        to.path == "/record" ||
        to.path == "/setpasswd" ||
        to.path == "/withdraw" ||
        to.path == "/turnTable" ||
        to.path == "/recharge" ||
        to.path == "/centerWallet" ||
        to.path == "/setting" ||
        to.path == '/recente' ||
        to.path == '/activity/red' || to.path == "/agent" || to.path == "/article" || to.path == "/teamList" ||
        to.path == '/support' ||
        to.path == '/report/report' ||
        to.path == '/recoveBalance' ||
        to.path == '/report/detail' || to.path == '/home'
      ) {
        this.isShowFt = false;
      } else {
        this.isShowFt = true;
      }
      if (to.path == "/activity/red") {
        this.isShowRed = true;
      } else {
        this.isShowRed = false;
      }
      if (to.path == "/article" || to.path == "/agent" || to.path == "/activity/red" || to.path == "/turnTable") {
        if (to.query.index) {
          this.isShowBottom = true
        } else {
          this.isShowBottom = false
        }
      } else {
        this.isShowBottom = false
      }
      console.log(to)
    },
  },
  updated() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted() {
    let _this = this;

    // 初始化点击音效
    this.initClickSound();

    // 监听浏览器返回事件
    this.handlePopState = () => {
      _this.isBackNavigation = true;
    };
    window.addEventListener('popstate', this.handlePopState);

    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleGlobalClick);

    // 将音效控制方法暴露到全局，方便控制
    window.toggleClickSound = this.toggleClickSound;

    // if (document.documentElement.clientWidth > 900) {
    //   _this.isShowFt = true;
    // }
    // window.onresize = function () {
    //   console.log("宽度", document.documentElement.clientWidth);
    //   console.log("高度", document.documentElement.clientHeight);
    //   if (document.documentElement.clientWidth > 900) {
    //     _this.isShowFt = true;
    //     console.log(_this.isShowFt);
    //   }
    // };
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('popstate', this.handlePopState);
    document.removeEventListener('click', this.handleGlobalClick);

    // 清理音频资源
    if (this.clickAudio) {
      this.clickAudio.removeEventListener('ended', () => { });
      this.clickAudio.removeEventListener('error', () => { });
      this.clickAudio = null;
    }
  },
  created() {
    let _this = this;
    router.beforeEach((to, from, next) => {
      let token = localStorage.getItem("token");
      if (to.fullPath == "/support" || from.fullPath == "/support") {
        return next();
      }
      if (to.redirectedFrom == '/showRegistro') {
        _this.register();
        return false;
      }
      if (!token) {
        _this.login();
        return false;
      }
      return next();
    });
  },
  methods: {
    // 过渡动画相关方法
    beforeEnter() {
      // 进入过渡前的处理
    },
    enter(el, done) {
      // 进入过渡时的处理
      done()
    },
    afterEnter() {
      // 进入过渡后的处理
    },
    // 音效相关方法
    playClickSound() {
      if (!this.clickSoundEnabled || this.clickSoundPlaying) {
        return;
      }

      try {
        this.clickSoundPlaying = true;
        this.clickAudio.currentTime = 0; // 重置播放位置
        const playPromise = this.clickAudio.play();

        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.log('音效播放失败:', error);
            this.clickSoundPlaying = false;
          });
        }
      } catch (error) {
        console.log('音效播放出错:', error);
        this.clickSoundPlaying = false;
      }
    },
    handleGlobalClick() {
      // 所有点击事件都播放音效
      this.playClickSound();
    },
    toggleClickSound() {
      this.clickSoundEnabled = !this.clickSoundEnabled;
      localStorage.setItem('clickSoundEnabled', this.clickSoundEnabled);
    },
    initClickSound() {
      try {
        // 从localStorage读取音效开关状态
        const savedSoundSetting = localStorage.getItem('clickSoundEnabled');
        if (savedSoundSetting !== null) {
          this.clickSoundEnabled = JSON.parse(savedSoundSetting);
        }

        // 创建音频对象
        this.clickAudio = new Audio(require('@/assets/music/click.mp3'));
        this.clickAudio.preload = 'auto';
        this.clickAudio.volume = 0.5; // 设置音量为50%

        // 监听音频播放结束事件
        this.clickAudio.addEventListener('ended', () => {
          this.clickSoundPlaying = false;
        });

        // 监听音频加载出错事件
        this.clickAudio.addEventListener('error', () => {
          console.log('音效文件加载失败');
          this.clickSoundPlaying = false;
        });

      } catch (error) {
        console.log('音效初始化失败:', error);
      }
    },
    invitation_code_change() {
      if (this.register_data.invite_code == "") {
        this.isTrueInvitation_code = true;
        return;
      }
      // let code = this.testParma(this.register_data.invite_code);
      // if (code) {
      //   this.isTrueInvitation_code = true
      //   this.register_data.invite_code = code;
      // } else {
      //   this.isTrueInvitation_code = false
      // }
    },
    closeDowLoad() {
      const data = {
        value: 1,
        date: new Date().getTime()
      }
      localStorage.setItem("dowLoad", JSON.stringify(data))
      this.showDownload = false;
    },
    getInviteCodeFromUrl() {
      let rawCode = '';

      // 方法1：尝试从标准查询参数获取 (?key=value)
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has('invite_code')) {
        rawCode = queryParams.get('invite_code');
      }

      // 方法2：如果没找到，尝试从hash部分解析 (#/path?key=value)
      if (!rawCode) {
        const hash = window.location.hash;
        const hashQueryIndex = hash.indexOf('?');

        if (hashQueryIndex !== -1) {
          const queryString = hash.substring(hashQueryIndex + 1);
          const hashParams = new URLSearchParams(queryString);
          if (hashParams.has('invite_code')) {
            rawCode = hashParams.get('invite_code');
          }
        }
      }

      return rawCode;
    },
    getImagePath(index) {
      return require(`@/assets/images/act/${index + 1}.png`);
    },
    changeAct(index) {
      this.act_active = index;
      if (index == 0) {
        this.$router.push({
          path: "/agent",
          query: { index: index },
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/turnTable",
          query: { index: index },
        });
      } else if (index == 6) {
        this.$router.push({
          path: "/article",
          query: { "signShow": "true", index: 6 },
        });
      } else {
        this.$router.push({
          path: "/article",
          query: { index: index },
        });
      }
      this.$nextTick(() => {
        const element = this.$refs[`item-${index}`][0];
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      })
    },
    ShowPwd(i) {
      var password = document.getElementById("password" + i);
      if (password.type == "password") {
        password.type = "text";
        this.showPwd[i] = true;
        this.isShowPwd = true
        // this.isShowPwd2 = true
      } else {
        password.type = "password";
        this.showPwd[i] = false;
        this.isShowPwd = false
        // this.isShowPwd2 = false
        //console.log(1);
      }
    },
    ShowPwd2(i) {
      var password = document.getElementById("password" + i);
      if (password.type == "password") {
        password.type = "text";
        this.isShowPwd2 = true
      } else {
        password.type = "password";
        this.isShowPwd2 = false
        //console.log(1);
      }
    },
    toSupport() {
      this.is_show_wrap = false
      this.is_show_login = false;
      this.is_show_register = false;
      this.isShowSupport = true;
      EventBus.$emit('supTabChange', 0);
    },
    getUrlParams() {
      let url = window.location.href;
      console.log("---------------------------")
      if (url.indexOf("?") == -1) return {};
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split("?")[1];
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      let paramsArr = urlStr.split("&");
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },
    submit_reigster() {
      if (this.isSubmitting) return
      if (!this.register_data.username) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("手机号码不能为空"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return false;
      }
      if (
        !this.register_data.password ||
        this.register_data.password.length < 6
      ) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("密码长度为6-18位"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return false;
      }
      if (this.register_data.password != this.register_data.repassword) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("两次密码不一致"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return false;
      }
      // if (!this.isTrueInvitation_code) {
      //   this.$message({
      //     title: this.$store.state.config.site_name,
      //     message: this.$t('请输入正确的邀请码。'),
      //     type: "error",
      //     center: true,
      //     showClose: true,
      //     offset: 300,
      //   });
      //   return false;
      // }
      this.register_data["url"] = window.location.href;
      this.isSubmitting = true
      Fetch("/user/register", this.register_data)
        .then((res) => {
          //console.log(res);s
          setTimeout(() => {
            this.isSubmitting = false
          }, 2000)
          if (res.code == 1) {
            //注册成功
            this.$message.success({
              title: this.$store.state.config.site_name,
              message: this.$t("注册成功"),
              center: true,
              showClose: true,
              offset: 300,
            });
            localStorage.setItem("login_username", this.register_data.username);
            localStorage.setItem("token", res.data?.userinfo?.token);
            localStorage.setItem("user_balance", 0);
            //保存账户密码
            localStorage.setItem("login_password", this.register_data.password);
            // fbq("track", "Purchase", { value: "0.00", currency: "USD" })
            this.token = res.data?.userinfo?.token
            this.showDownload = true;
            setTimeout(() => {
              this.is_show_wrap = false
              this.register_end_modal = true
            }, 200);
            EventBus.$emit('refresh_bet')
          } else {
            this.$message({
              title: this.$store.state.config.site_name,
              message: res.msg,
              type: "error",
              center: true,
              showClose: true,
              offset: 300,
            });
          }
        })
        .catch((e) => {
          setTimeout(() => {
            this.isSubmitting = false
          }, 2000)
          this.$message({
            title: this.$store.state.config.site_name,
            message: this.$t("系统繁忙,请稍后再尝试"),
            type: "error",
            center: true,
            showClose: true,
            offset: 300,
          });
          return false;
        });
    },
    submit_login() {
      if (!this.data.username) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("请输入正确的手机号码"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return;
      }
      if (!this.data.password) {
        this.$message({
          title: this.$store.state.config.site_name,
          type: "error",
          message: this.$t("密码长度为6至18个字符"),
          center: true,
          showClose: true,
          offset: 300,
        });
        return;
      }
      this.data.username = this.data.username.replace(
        new RegExp("[+]", "gm"),
        ""
      );
      Fetch("/user/login", {
        account: this.data.username,
        password: this.data.password,
        url: window.location.href
      }).then((res) => {
        //登录失败
        if (res.code == 0) {
          this.$message({
            title: this.$store.state.config.site_name,
            type: "error",
            message: res.msg,
            center: true,
            showClose: true,
            offset: 300,
          });
        } else {
          if (res.data.userinfo.token) {
            localStorage.setItem("token", res.data.userinfo.token);
            localStorage.setItem("user_balance", res.data.userinfo.money);
            this.token = res.data.userinfo.token
            this.user_balance = res.data.userinfo.money
          }
          this.$message.success({
            title: this.$store.state.config.site_name,
            message: this.$t("登录成功"),
            center: true,
            showClose: true,
            offset: 300,
          });
          //保存账户密码
          localStorage.setItem("login_username", this.data.username);
          localStorage.setItem("login_password", this.data.password);
          //跳转到首页
          setTimeout(() => {
            this.$router.push({ path: '/index' });
            this.is_show_wrap = false
            this.showDownload = true;
            EventBus.$emit('refresh_bet')
            EventBus.$emit('getUserInfo')
          }, 400);
        }
      });
    },
    login() {
      this.data.username = localStorage.getItem("login_username")
        ? localStorage.getItem("login_username")
        : "";
      this.is_show_wrap = true;
      this.is_show_login = true;
      this.is_show_register = false;
      this.getAllInput()
      return;
    },
    register() {
      this.is_show_wrap = true;
      this.is_show_login = false;
      this.is_show_register = true;
      this.getAllInput()
      return;
    },
    getAllInput() {
      const ls = document.getElementsByClassName('item')
      console.log(ls)
    },
    closeWindow() {
      this.is_show_wrap = false;
      this.is_show_login = false;
      this.is_show_register = false;
    },
    tabChange(v) {
      this.nav_active = v;
      if (v == 0) {
        this.getGameList();
      }

      if (v == 1) {
        this.all_game_list = [];
        let allGames = [];
        this.all_game_list_bak.forEach((item) => {
          item.game_list.forEach((game) => {
            if (game.origin == "PG") {
              allGames.push(game);
            }
          });
        });
        this.all_game_list.push({
          origin: "PG Slots",
          game_list: allGames,
        });
      }
      if (v == 2) {
        this.all_game_list = [];
        let allGames = [];
        this.all_game_list_bak.forEach((item) => {
          item.game_list.forEach((game) => {
            if (game.origin == "TADA") {
              allGames.push(game);
            }
          });
        });
        this.all_game_list.push({
          origin: "TADA Slots",
          game_list: allGames,
        });
      }
      if (v == 3) {
        let localGames = localStorage.getItem("local_game_list");
        if (!localGames) {
          let json_obj = { PG: [], JDB: [], TADA: [] };
          localStorage.setItem("local_game_list", JSON.stringify(json_obj));
          localGames = localStorage.getItem("local_game_list");
        }
        Fetch("/Game/getGameById", JSON.parse(localGames)).then((res) => {
          let _this = this;
          this.all_game_list = res.data;
          this.all_game_list_bak = res.data;
          this.max_show_array = [];
          res.data.forEach(() => {
            _this.max_show_array.push(6);
          });
        });
      }
    },

    changeBalance(val) {
      this.user_balance = val;
    },
    onSwipeLeft(even, start, end) {
      //console.log(window.location.href);

      if (window.location.href.indexOf("signature")) {
        return false;
      }
      if (end["X"] - start["X"] > 60) {
        this.$router.go(-1);
      }
    },
    bigNumeber(str) {
      var str = str.toString();
      var strs = str.split(".");
      var s1 = strs[0] || 0;
      var s2 = strs[1] || "00";
      return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
    },
    changeActive(e) {
      console.log(e, 'e=====')
    },
    openRecharge() {
      this.register_end_modal = false;
      this.isShowRecharge = true;
    }
  },
};
</script>

<style lang="less">
@import "./assets/css/variables.less";

html,
body {
  // width: 100%;
  // height: 100%;
  // overflow-y: scroll;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB,
    Microsoft Yahei, sans-serif !important;
  user-select: none !important;
}

/* 优化滚动条样式 */
html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
}

html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  transition: background 0.3s ease;
}

html::-webkit-scrollbar-thumb:hover,
body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.5);
}

/* 移动端隐藏滚动条 */
@media screen and (max-width: 768px) {

  html::-webkit-scrollbar,
  body::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

html {
  background-color: @third-color;
}

body {
  max-width: @maxWidth;
  height: 100vh;
  margin: 0 auto !important;
  position: relative;
  // overflow: hidden;
}

// 路由过渡动画
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}

.slide-left-enter {
  transform: translateX(100%);
}

.slide-left-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter {
  transform: translateX(-100%);
}

.slide-right-leave-to {
  transform: translateX(100%);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

// 设置过渡容器
#vier_port {
  position: relative;
  width: 100%;
  min-height: 100vh;
}


// 通用滚动条优化
* {
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

// 优化所有滚动容器
*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

*::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}

*::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  transition: all 0.3s ease;
}

*::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.4);
}

*::-webkit-scrollbar-corner {
  background: transparent;
}

// 移动端优化
@media screen and (max-width: 768px) {
  * {
    scrollbar-width: none;
  }

  *::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  // 添加更好的滚动回弹效果
  body,
  html {
    -webkit-overflow-scrolling: touch;
  }
}
</style>
<style lang="less" scoped>
@import "./assets/css/login&register.less";
@import "./assets/css/phone.css";
@import "./assets/css/pad.css";
@import "./assets/css/pc.less";
@import "./assets/css/default.less";
@import "./assets/css/variables.less";

@headerHeight: 1.2rem;


/deep/ .el-notification__group {
  color: red !important;
}

.red {
  background-color: #b10b10;
}

/deep/ .van-popup {
  max-width: @maxWidth !important;
}

// /deep/ .van-popup--right {
//   left: 3.7rem;
// }

#app {
  min-height: 100%;
  height: auto;
  width: 100%;
  overflow-x: hidden;
  background-color: @secondary-color;
}


.disabled-style {
  opacity: 0.6;
  cursor: not-allowed;
}

.el-picker-panel {
  z-index: 9999 !important;
}

.el-message--warning {
  z-index: 100000 !important;
}

.lrgg img {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0.2rem;
  background: #fff;
  border-radius: 50%;
}

.bottom_dom {
  // padding: .2rem .2rem 1.4rem .2rem;
  color: #fff;
  width: 100%;
  overflow-x: scroll;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;

  .actList {
    display: flex;
    overflow: auto;
    // width: -moz-max-content;
    width: max-content;

    .act_item {
      width: 3rem;
      min-height: 1.4rem;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      margin-right: .2rem;
      cursor: pointer;

      .item-img {
        padding: .04rem;
        height: 1.4rem;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          border-radius: .15rem;
        }

        .active {
          border: 0.05rem solid @anttextcolor;
        }
      }


      .act_name {
        font-size: .3rem;
        margin-top: .04rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        width: 100%;
        color: @anttextcolor;
      }
    }

  }
}

.register_end_box {
  width: 88%;
  background-color: @primary-color;
  border: 1px solid @bodercolor2;
  border-radius: 12px;

  .register_end {
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .register_title {
      color: @textcolorf;
      font-size: 18px;
      margin: 6px 0 10px;
    }

    .register_content {
      color: @popupTextColor;
      font-size: 10px;
      margin-bottom: 40px;
    }

    .register_btn {
      width: 100%;
      color: @activityColor;
      font-size: 10px;
      background-color: @ButtonColor;
      text-align: center;
      padding: 8px;
      box-sizing: border-box;
      border-radius: 6px;
    }

  }
}

/deep/ .van-overlay {
  background-color: rgba(0, 0, 0, .5);
  z-index: 2000 !important;
}

.recharge_box {
  background-color: @secondary-color;
}

@media only screen and (min-width: 992px) {
  .van-popup--right {
    right: auto;
  }
}
</style>
